import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

export class NotificationService {
  /**
   * Inicializa o serviço de notificações, solicitando permissões
   */
  static async init() {
    if (!Capacitor.isNativePlatform()) {
      console.log('Notificações push/locais não são suportadas na web (apenas App Nativo).');
      return;
    }

    try {
      // Registrar e solicitar permissão para Push Notifications
      let permStatus = await PushNotifications.checkPermissions();
      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
      }

      if (permStatus.receive === 'granted') {
        await PushNotifications.register();
      }

      // Adicionar listeners para Push (se aplicável ao Firebase no futuro)
      await PushNotifications.addListener('registration', token => {
        console.log('Push registration success, token: ' + token.value);
        // TODO: Enviar token para o backend (Supabase)
      });

      await PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('Push received: ', notification);
      });

      await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        console.log('Push action performed: ', notification);
      });
      
    } catch (error) {
      console.error('Erro ao inicializar notificações:', error);
    }
  }

  /**
   * Dispara uma notificação local imediatamente (ex: Novo Lead recebido via WebSocket)
   */
  static async showLocalNotification(title: string, body: string) {
    if (!Capacitor.isNativePlatform()) {
      // Fallback para Web Notifications se estiver rodando no navegador
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification(title, { body });
      }
      return;
    }

    try {
      await LocalNotifications.schedule({
        notifications: [
          {
            title: title,
            body: body,
            id: new Date().getTime(),
            schedule: { at: new Date(Date.now() + 1000) }, // Agendar para 1 segundo no futuro
            sound: undefined,
            attachments: null,
            actionTypeId: '',
            extra: null
          }
        ]
      });
    } catch (error) {
      console.error('Erro ao disparar notificação local:', error);
    }
  }
}
